import './scss/style.scss';
import './styles/tailwind.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import './i18n'; // initializes react-i18next
import { LocaleProvider } from './context/LocaleContext';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import fetchApi from './util/fetchApi';
import { silenceLibraryDeprecations } from './util/silenceLibraryDeprecations';
import { AuthProvider, getToken } from './context/AuthContext';

import { ENDPOINT, SENTRY_DSN } from './constants';

// Mute @rjsf/core v4's harmless `defaultProps` deprecation noise in dev.
silenceLibraryDeprecations();

fetchApi.configure({
  defaults: { baseurl: ENDPOINT },
  verbs: ['get', 'post', 'put', 'delete'],
  helpers: {
    api: (url, options, fetchApi) =>
      fetchApi(
        url,
        {
          auth: { type: 'Bearer', token: getToken() },
          json: true,
          ...options,
        },
        fetchApi
      ),
    external: (url, options, fetchApi) =>
      fetchApi(
        url,
        {
          json: true,
          baseUrl: undefined,
          ...options,
        },
        fetchApi
      ),
    lookup: (url, options, fetchApi) =>
      fetchApi(
        `form-lookup/${url}`,
        {
          auth: { type: 'Bearer', token: getToken() },
          json: true,
          useCache(url, options) {
            return options.method === 'get';
          },
          ...options,
        },
        fetchApi
      ),
  },
});

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
  });
}

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('app-root');

function MainApp() {
  return (
    <LocaleProvider>
      <BrowserRouter basename={baseUrl}>
        <App />
      </BrowserRouter>
    </LocaleProvider>
  );
}

const root = createRoot(rootElement);
root.render(<MainApp />);

registerServiceWorker();
